export function pluralWord(count, singular, plural = `${singular}s`) {
  return Number(count) === 1 ? singular : plural;
}
